import React, { useState, useEffect } from "react";
import Select from "react-select";
import logo from "../images/navbar/newlogo2.png";
import search from "../images/navbar/Vector.png";
import locationpic from "../images/navbar/location.png";
import { useNavigate } from "react-router-dom";
import EmpOptions from "./EmpOptions";
import CandidateOpt from "./CandidateOpt";
import StaffOptions from "./StaffOptions";

function Navbar() {
    const navigate = useNavigate();
    const companyName = sessionStorage.getItem("customerName");
    const [job, setJob] = useState("");
    const [locationInput, setLocationInput] = useState("");
    const [locationOptions, setLocationOptions] = useState([]);
    const [locationError, setLocationError] = useState("");
    const [showOptions, setShowOptions] = useState(false);
    const customerType = sessionStorage.getItem("customerType");
    const selectedPlan = sessionStorage.getItem("selectedPlan");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        const fetchLocationData = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/data`);
                if (!response.ok) return;
                const data = await response.json();
                const districts = data?.states?.flatMap((s) => s.districts || []) || [];
                const unique = [...new Set(districts)].sort();
                setLocationOptions(unique.map((d) => ({ value: d, label: d })));
            } catch (err) {
                console.error("Failed to load locations", err);
            }
        };
        if (apiBaseUrl) fetchLocationData();
    }, [apiBaseUrl]);

    const login = () => navigate("/login");
    const home = () => navigate("/home");
    const regchooses = () => navigate("/regchoose");

    const findJob = () => {
        // Validate location only if provided; allow empty to show all locations
        if (locationInput) {
            const exists = locationOptions.some((o) => o.value.toLowerCase() === locationInput.toLowerCase());
            if (!exists) {
                setLocationError("Please select a location from the list.");
                return;
            }
        }
        setLocationError("");
        const params = new URLSearchParams();
        if (job && job !== "All") params.append("job", job);
        if (locationInput) params.append("location", locationInput);
        navigate(`/searchedjobs?${params.toString()}`);
    };

    const toggleOptions = () => setShowOptions(!showOptions);
    const closeOptions = () => setShowOptions(false);

    return (
        <div className="h-[100px] w-full lg:px-12 px-3 flex items-center flex-row gap-5">
            {/* Left - Logo */}
            <img src={logo} alt="logo" className="w-[15%] h-[60%] cursor-pointer shrink-0" onClick={home} />

            {/* Center - Search bar (only for candidates without plan) */}
            {(!customerType ||
                customerType === "admin" ||
                customerType === "mainAdmin" ||
                (customerType === "candidate" && selectedPlan === "null")) && (
                <div className="h-[48px] flex-1 max-w-3xl mx-auto flex flex-row justify-center items-center border-[#edebeb] border-2">
                    <div className="h-full w-[40%] flex flex-row border-r-2 border-[#edebeb]">
                        <div className="h-full w-[20%] flex justify-center items-center">
                            <img src={search} alt="vector" />
                        </div>
                        <div className="h-full w-[80%]">
                            <input
                                type="text"
                                value={job}
                                onChange={(e) => setJob(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && findJob()}
                                placeholder="Search job name..."
                                className="w-full h-full outline-none text-base px-2"
                            />
                        </div>
                    </div>

                    <div className="h-full w-[40%] flex flex-row">
                        <div className="h-full w-[20%] flex justify-center items-center">
                            <img src={locationpic} alt="location" />
                        </div>
                        <div className="h-full w-[80%]">
                            <Select
                                options={locationOptions}
                                value={locationOptions.find((o) => o.value === locationInput) || null}
                                onChange={(opt) => {
                                    setLocationInput(opt?.value || "");
                                    setLocationError("");
                                }}
                                placeholder="Select Location..."
                                classNamePrefix="react-select"
                                className="w-full h-full"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: "100%",
                                        minHeight: "46px",
                                        border: "none",
                                        boxShadow: "none",
                                        backgroundColor: "transparent",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "100%",
                                        padding: "0 8px",
                                        display: "flex",
                                        alignItems: "center",
                                    }),
                                    indicatorsContainer: (base) => ({ ...base, display: "none" }),
                                }}
                            />
                            {locationError && <p className="text-red-500 text-xs px-1 mt-1">{locationError}</p>}
                        </div>
                    </div>

                    <div className="h-[70%] w-[20%] flex justify-center items-center">
                        <div
                            className="h-full w-[80%] rounded-[10px] bg-[#E22E37] flex justify-center items-center text-white cursor-pointer text-base font-semibold font-display hover:bg-red-700"
                            onClick={findJob}
                        >
                            Find Job
                        </div>
                    </div>
                </div>
            )}

            {/* Right side - auth buttons + user name */}
            <div className="ml-auto flex items-center gap-4 shrink-0">
                {companyName ? (
                    <div
                        className="h-[48px] min-w-[180px] max-w-[320px] px-5 flex items-center justify-center gap-3 bg-[#E22E37] rounded-[5px] text-white cursor-pointer hover:bg-red-700"
                        onClick={toggleOptions}
                    >
                        <span className="text-base font-semibold font-display truncate">{companyName}</span>
                    </div>
                ) : (
                    <>
                        <div
                            className="h-[48px] min-w-[100px] flex justify-center items-center border-2 border-[#E22E37] rounded-[5px] text-base font-semibold font-display cursor-pointer hover:bg-black hover:text-white transition-colors"
                            onClick={login}
                        >
                            Login
                        </div>

                        <div
                            className="h-[48px] min-w-[140px] flex justify-center items-center border-2 border-[#E22E37] rounded-[5px] text-base font-semibold font-display cursor-pointer hover:bg-black hover:text-white transition-colors"
                            onClick={regchooses}
                        >
                            Free Register
                        </div>
                    </>
                )}
            </div>

            {/* Dropdown menu when clicked */}
            {showOptions &&
                (customerType === "admin" || customerType === "mainAdmin" ? (
                    <StaffOptions closeOptions={closeOptions} />
                ) : customerType === "employee" ? (
                    <EmpOptions closeOptions={closeOptions} />
                ) : customerType === "candidate" ? (
                    <CandidateOpt closeOptions={closeOptions} />
                ) : null)}
        </div>
    );
}

export default Navbar;
